export enum ValidationIndustryStatus {
  PROHIBITED = 'validation_prohibited_industry',
  RESTRICTED = 'validation_restricted_industry',
}
